import { setPageData } from '../redux/reducers/pageData';

export const setFilterData = (data) => (dispatch) => {
  dispatch(setPageData({ field: 'filterData', value: data }));
};
